import { render, staticRenderFns } from "./PieChart copy.vue?vue&type=template&id=2d331f7a"
import script from "./PieChart copy.vue?vue&type=script&lang=js"
export * from "./PieChart copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports